import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function Payment({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      className={className}
    >
      <rect
        fill="none"
        width="18"
        height="13"
        x="3"
        y="6"
        strokeWidth="2"
        rx="2"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth="2"
        d="M7 15h.01M4 11h17"
      />
    </svg>
  );
}

export default Payment;
